import React, { useState } from "react";

const ByEmailPassword = ({ errors, setErrors, setLoginState, formState }) => {
  return (
    <>
      <div className="form-group mb-3">
        <label className="custom-label-style" htmlFor="email">
          Email <span style={{ color: "red" }}>*</span>
        </label>
        <input
          className={errors?.userName ? "invalid form-control" : "form-control"}
          value={formState?.userName}
          id="email"
          type="email"
          name="email"
          autoComplete="email"
          onChange={(e) => {
            setLoginState({
              ...formState,
              userName: e.target.value,
            });
            setErrors({
              ...errors,
              userName:  e.target.value ? "" : "Email is Mandatory"
              
            });
          }}
        />
        <p className="text-danger text-left font-size-xs">
          <small className="validation-errors d-block font-size-xs mt-1">
            {errors?.userName}
          </small>
        </p>
      </div>
      <div className="form-group mb-3">
        <div className="d-flex justify-content-between mt-n5">
          <label className="custom-label-style">
            Password <span style={{ color: "red" }}>*</span>
          </label>
        </div>
        <input
          id="userPassword"
          value={formState?.userPassword}
          className={
            errors?.userPassword ? "form-control invalid" : "form-control"
          }
          type="password"
          name="userPassword"
          autoComplete="current-password"
          onChange={(e) => {
            setLoginState({
              ...formState,
              userPassword: e.target.value,
            });
            setErrors({
              ...errors,
              userPassword: e.target.value ? "" : "Password is Mandatory"
                
            });
          }}
        />
        <p className="text-danger text-left font-size-xs">
          <small className="validation-errors d-block font-size-xs mt-1">
            {errors?.userPassword}
          </small>
        </p>
      </div>
    </>
  );
};

export default ByEmailPassword;
